import { Box } from "@chakra-ui/react";
import _ from "lodash";
import { useSelector } from "react-redux";
import TicketsByBranchReport from "../../components/organization/reports/TicketsByBranch";
import { getReportDescription } from "../../store/helpers";
import * as defaultSelectors from "../../store/selectors/defaultSelector";
import {
  TICKET_SUMMARY_COLUMN_DEFINITIONS,
  getRenderConfigSummaryItems,
} from "../../store/renderConfig";

const TicketsPerBranch = ({
  
  reportIndex = "**REPORT_INDEX**",
}) => {
  const reportRange = useSelector(defaultSelectors.selectReportRange);
  const reportsData = useSelector(defaultSelectors.selectReportsData);
  const renderConfig = useSelector(defaultSelectors.selectRenderConfig);
  const { data } = reportsData;

  const title = `${reportIndex}. Tickets Per Branch`;
  const presentationSummaryItems = getRenderConfigSummaryItems(renderConfig, {
    columnDefinitions: TICKET_SUMMARY_COLUMN_DEFINITIONS,
  });

  return (
    <Box>
      <h1>{title}</h1>
      <p>{getReportDescription(reportRange).TicketsByBranch}</p>
      {presentationSummaryItems.length ? (
        <div className="reportPresentationSummary">
          <strong>PRESENTATION</strong> {presentationSummaryItems.join(" / ")}
        </div>
      ) : null}
      {!_.isEmpty(data) ? (
        <>
          <TicketsByBranchReport reportIndex={reportIndex} data={data} renderConfig={renderConfig} />
        </>
      ) : (
        <Box mt={10}>
          <p>No data available in this search</p>
        </Box>
      )}
    </Box>
  );
};

export default TicketsPerBranch;
